import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=451ca329&scoped=true&lang=html&"
import script from "./Term.vue?vue&type=script&lang=ts&"
export * from "./Term.vue?vue&type=script&lang=ts&"
import style0 from "./Term.vue?vue&type=style&index=0&id=451ca329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ca329",
  null
  
)

export default component.exports